import ApiHandler from "./ApiHandler";

const Education = {
  getMyOne: async () => await ApiHandler.i.auth().get('/education'),
  getOne: async (userId) => await ApiHandler.i.auth().get(`/education/${userId}`),
  putFile: async (data, options) => await ApiHandler.i.auth().put(`/education/file`, data, options),
};

export default Education;